import { useState } from 'react';
// @mui
import {
  Box,
  Typography,
  Collapse,
  Stack,
  IconButton,
} from '@mui/material';
// hooks
import useAuth from '../../../../hooks/useAuth';
import useResponsive from '../../../../hooks/useResponsive';
// components
import { MotionViewport } from '../../../../components/animate';
import Iconify from '../../../../components/Iconify';
// sections
import { PositionCard, SelectedPositionCard } from '../../../../sections/register/position';
// constants
import { POSITION_OPTIONS } from '../../../../constants'
// utils
import axios from '../../../../utils/axios';

// ----------------------------------------------------------------------

const positions = POSITION_OPTIONS;

export default function SetPositionForm({ jobPost, next, close }) {
  const { user } = useAuth();
  const [selectedPosition, setSelectedPosition] = useState(null);
  const [isSelected, setIsSelected] = useState(false);
  const smUp = useResponsive('up', 'sm');

  const postNewJobPost = async (position) => {
    try {
      const companyId = user?.employee.company[0].id;
      const jobPostData = {
        pk: jobPost ? jobPost.id : null,
        position: position.key,
      };
      const response = await axios.post(
        `api/company/${companyId}/job-posts/`,
        jobPostData
      )
      const jobPostId = response.data?.id
      await next(jobPostId);
    } catch(err) {
      console.error(err);
    }
  }

  const selected = (position) => {
    if (isSelected) return;
    setSelectedPosition(position);
    setIsSelected(true);
    setTimeout(() => postNewJobPost(position), 200);
  }

  return (
    <>
      <Stack alignItems="flex-end" sx={{ mb: smUp ? 3 : 6 }}>
        <IconButton color="inherit" edge="end" onClick={close}>
          <Iconify icon="ic:round-close" sx={{ width: smUp ? 32 : 24 , height: smUp ? 32 : 24, color: (theme) => theme.palette.text.disabled }} />
        </IconButton>
      </Stack>

      <Typography variant="h4" gutterBottom>
        회사에 어떤 분이 필요한지 알려주세요.
      </Typography>
      <Typography sx={{ color: (theme) => theme.palette.text.secondary }} variant={smUp ? "body1" : "body2"} gutterBottom>
        여러 포지션을 찾고 계신다면, 이 공고 작성을 완료한 후 추가로 작성해주세요.
      </Typography>
      <Box
        component={MotionViewport}
        sx={{
          my: 4,
          display: 'grid',
          gap: 3,
          gridTemplateColumns: {
            xs: 'repeat(1, 1fr)',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(4, 1fr)',
          },
        }}
      >
        {positions.map((position, index) => (
          <PositionCard position={position} key={index} onClick={() => selected(position)} selected={selectedPosition?.key} />
        ))}
      </Box>

      <Collapse
        in={isSelected}
        {...(isSelected ? { timeout: 500 } : {})}
      >
        <SelectedPositionCard position={selectedPosition} />
      </Collapse>
    </>
  )
}